import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setShareResultsSettings, useShareResultsSettings } from 'reducers/reviewCreationSlice';

import { RadioSelect } from 'uiToolkitV1/RadioSelect';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ShareResultsSettings } from '../../../Hooks/dataHooks/shareResultsDataHooks';

export const ManagerScoreVisibility = ({ feedbackFormId }) => {
  const dispatch = useDispatch();
  const selfScoreSettings: ShareResultsSettings = useShareResultsSettings({ feedbackFormId });

  const handleChange = (index: number) => {
    dispatch(
      setShareResultsSettings({
        feedbackFormId,
        settings: { isShowManagerRating: index === 0 },
      })
    );
  };

  const selectedIndex = selfScoreSettings.isShowManagerRating ? 0 : 1;

  return (
    <Flex flexDir="column" gap={3}>
      <Flex alignItems="center" gap={2}>
        <TextBodyMedium>Can self see the Manager Score?</TextBodyMedium>
        <TooltipInfoV1 title="Post the review publish, visibility of manager score to employees" />
      </Flex>
      <RadioSelect
        name=""
        options={[{ name: 'Show' }, { name: "Don't Show" }]}
        onChange={handleChange}
        containerProps={{ mt: 0 }}
        selectedIndex={selectedIndex}
      />
    </Flex>
  );
};
